import cloneDeep from 'lodash/cloneDeep'

export function cleanData(obj) {
	obj = cloneDeep(obj)
  for (let p in obj) { 
    if (obj[p] == null || obj[p] === '') {
    	// delete null or empty key
      delete obj[p];
      continue;
    } 
    else if (typeof obj[p] === 'object' && !Array.isArray(obj[p])) {
    	// apply recursively
    	obj[p] = cleanData(obj[p]);
		}
  }
  return obj;
}



// WEBPACK FOOTER //
// ./src/utils/data.js